module.exports = __webpack_public_path__ + "img/consultation.d52dd86a.gif";